import { Button, CircularProgress, Alert } from "@mui/material";
import { useLiteRaveCreateContext } from "../LiteRaveCreateContext";

export const Actions = () => {
  const { loading, error } = useLiteRaveCreateContext();

  return (
    <>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Button
        fullWidth
        variant="contained"
        size="large"
        type="submit"
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Create Rave"
        )}
      </Button>
    </>
  );
};
